var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74222 14.0444C5.70667 12.9956 4.40889 11.9111 4.40889 10.2222C4.40889 8.28444 6.20444 6.93333 9.20889 6.93333C12.3733 6.93333 13.5467 8.44444 13.6533 10.6667H17.5822C17.4578 7.60889 15.5911 4.8 11.8756 3.89333V0H6.54222V3.84C3.09333 4.58667 0.32 6.82667 0.32 10.2578C0.32 14.3644 3.71555 16.4089 8.67556 17.6C13.12 18.6667 14.0089 20.2311 14.0089 21.8844C14.0089 23.1111 13.1378 25.0667 9.20889 25.0667C5.54667 25.0667 4.10667 23.4311 3.91111 21.3333H0C0.213333 25.2267 3.12889 27.4133 6.54222 28.1422V32H11.8756V28.1778C15.3422 27.52 18.0978 25.5111 18.0978 21.8667C18.0978 16.8178 13.7778 15.0933 9.74222 14.0444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.3810061325a2cfa8ccbf8273affb3e3f.svg";
export { ForwardRef as ReactComponent };